"use strict";

var _a;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RUNNING_VERSION = void 0;
exports.RUNNING_VERSION = (_a = process.env.CURRENT_VERSION) !== null && _a !== void 0 ? _a : 'v3';